export default __webpack_public_path__ + "assets/webgl/indicator.2032e31d.png";